<template>
  <div class="input-id-add">
    <div class="inner">
      <c-Input v-bind="inputIdAddBind" v-model="inputIdAddModel" :name="'idList'" @keydown.enter.prevent/>
      <c-btnLine01 :btnText="t('message.add')" @click.stop="addAdmin"/>
      <c-btnLine01 :btnText="t('message.loadData')" class="c02" v-show="isShowLoading" @click="onClickShowDialog" :disabled="popupIdx == 0"/>
    </div>
    <div class="tag-group">
      <v-chip closable @click:close="deleteAdmin(item)"
              v-for="(item, i) in storeRef.adminList.value"
              :key="item.idx">
        {{ item.memberId }}
      </v-chip>
    </div>
  </div>
  <DialogTargetAdd
    v-model="isShowDialog"
    @close="isShowDialog=false"
    @confirm="confirmShowDialog"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import OrganizationService from "@/services/organization.service";
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//props
const props = defineProps(['isShowLoading', 'idList', 'type'])

//bind
const snackbar = ref(false)
const snackText = ref('')
const isShowDialog = ref(false)
const popupIdx = ref<number>(Number(storeRef.popupIdx.value))
const inputIdAddModel = ref('')
const inputIdAddBind = computed(() =>({
  type: 'text',
  placeholder: t('message.enterGroupUserId'),
}))

//function
const addAdmin=()=>{
  if(inputIdAddModel.value){
    let params = {
      memberId: inputIdAddModel.value,
    }
    MemberService.getMember(params).then(
      (response) => {
        let isSame = false
        if(props.type == 'client')
          isSame = response.result.clientIdx == popupIdx.value
        else if(props.type == 'company')
          isSame = response.result.companyIdx == popupIdx.value
        if(!response.result.memberId || isSame)
          storeRef.adminList.value.push({memberId:inputIdAddModel.value, memberIdx:response.result.idx});
        else {
          snackText.value = t('message.accountAlreadyExists')
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const deleteAdmin=(admin)=>{
  let resultArr = _.reject(storeRef.adminList.value, (item) => item.idx === admin.idx)
  storeRef.adminList.value = resultArr
}

const onClickShowDialog=()=>{
  if(popupIdx.value != 0)
    isShowDialog.value=true
}

const confirmShowDialog=(item)=>{
  inputIdAddModel.value = item.memberId
  isShowDialog.value=false
  addAdmin()
}
</script>
<style lang="scss"> //scoped
.input-id-add{
  display:flex;
  flex-direction: column;
  width:100%;
  .inner{
    display:flex;
    width:100%;
    .input-txt-group{
      width:100%;
      & + [class*="btn-"]{margin-left:1rem }
    }
    [class*="btn-"] + [class*="btn-"]{
      margin-left:1rem
    }
  }
  .tag-group{
    margin-top:1rem;
    .v-chip{
      font-size:1.5rem;
      border-radius:.4rem;
      margin-right:.7rem;
      margin-bottom:.7rem;
      &.v-chip--variant-tonal .v-chip__underlay{
        background:var(--chip-bg);
      }
      .v-chip__content{
        letter-spacing:0;
      }
      .mdi-close-circle::before{
        opacity:.7;
      }
    }
  }

}
</style>
